import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vShow as _vShow, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-f42c9a32"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "marcas-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "marcas-content" };
const _hoisted_4 = { style: { "display": "flex", "justify-content": "space-between", "align-items": "center", "margin-bottom": "1.5rem", "gap": "1rem", "flex-wrap": "wrap" } };
const _hoisted_5 = { class: "hero-tabs-premium m-0 text-sm" };
const _hoisted_6 = {
    class: "header-top-controls",
    style: { "margin-bottom": "0" }
};
const _hoisted_7 = { class: "search-container" };
const _hoisted_8 = { class: "search-wrapper" };
const _hoisted_9 = {
    class: "dropdown-filters",
    style: { "margin-right": "8px", "margin-left": "8px" }
};
const _hoisted_10 = { class: "filter-group select-filter" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: 0 }, "Todos los tipos", -1 /* HOISTED */));
const _hoisted_12 = ["value"];
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Nuevo Almacén", -1 /* HOISTED */));
const _hoisted_14 = {
    id: "traslados-controls-target",
    style: { "flex": "1", "display": "flex", "justify-content": "flex-end" }
};
const _hoisted_15 = { class: "filter-controls" };
const _hoisted_16 = { class: "alphabet-filter" };
const _hoisted_17 = ["onClick"];
const _hoisted_18 = { class: "table-container shadow card" };
const _hoisted_19 = { class: "marcas-table" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Código / Nombre"),
        /*#__PURE__*/ _createElementVNode("th", null, "Datos Ubicación"),
        /*#__PURE__*/ _createElementVNode("th", null, "Categoría"),
        /*#__PURE__*/ _createElementVNode("th", null, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_21 = { key: 0 };
const _hoisted_22 = {
    colspan: "5",
    class: "text-center py-8"
};
const _hoisted_23 = { class: "loading-state" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-muted" }, "Cargando almacenes...", -1 /* HOISTED */));
const _hoisted_25 = { key: 1 };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "5",
    class: "text-center py-4 text-muted"
}, "No se encontraron almacenes registrados.", -1 /* HOISTED */));
const _hoisted_27 = [
    _hoisted_26
];
const _hoisted_28 = {
    class: "attribute-badge",
    style: { "color": "#3b82f6" }
};
const _hoisted_29 = { style: { "font-weight": "600", "margin-top": "4px", "color": "#334155" } };
const _hoisted_30 = { style: { "display": "flex", "flex-direction": "column", "gap": "2px" } };
const _hoisted_31 = { style: { "font-size": "0.9rem", "font-weight": "500", "color": "#1e293b" } };
const _hoisted_32 = { style: { "font-size": "0.8rem", "color": "#64748b" } };
const _hoisted_33 = { class: "type-badge-retail" };
const _hoisted_34 = { class: "actions-column" };
const _hoisted_35 = ["onClick", "title"];
const _hoisted_36 = ["onClick"];
const _hoisted_37 = ["href"];
const _hoisted_38 = ["onClick"];
const _hoisted_39 = ["onClick"];
const _hoisted_40 = { class: "pagination-controls" };
const _hoisted_41 = ["disabled"];
const _hoisted_42 = ["disabled"];
const _hoisted_43 = { class: "total-count-display" };
const _hoisted_44 = { key: 0 };
const _hoisted_45 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_46 = { class: "modal-window large-modal x-large" };
const _hoisted_47 = { class: "modal-header header-dark-premium" };
const _hoisted_48 = { class: "modal-title-group" };
const _hoisted_49 = { class: "icon-bulb-premium" };
const _hoisted_50 = { class: "hero-text-content" };
const _hoisted_51 = { class: "modal-title-text text-white" };
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "rif-subtitle-text" }, "PLATAFORMA LOGÍSTICA", -1 /* HOISTED */));
const _hoisted_53 = { class: "form-scroll-area" };
const _hoisted_54 = { class: "premium-form-card" };
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-badge-premium" }, "Identidad Legal", -1 /* HOISTED */));
const _hoisted_56 = { class: "grid-layout-premium" };
const _hoisted_57 = { class: "input-group-premium" };
const _hoisted_58 = { class: "input-group-premium" };
const _hoisted_59 = { class: "input-group-premium full-col" };
const _hoisted_60 = { class: "input-group-premium" };
const _hoisted_61 = { class: "input-group-premium" };
const _hoisted_62 = { class: "truncate" };
const _hoisted_63 = { class: "premium-form-card mt-6" };
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-badge-premium operational" }, "Operación y Capacidad", -1 /* HOISTED */));
const _hoisted_65 = { class: "grid-layout-premium" };
const _hoisted_66 = { class: "input-group-premium full-col" };
const _hoisted_67 = { class: "input-group-premium" };
const _hoisted_68 = { class: "input-group-premium" };
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "Seleccione...", -1 /* HOISTED */));
const _hoisted_70 = ["value"];
const _hoisted_71 = { class: "input-group-premium" };
const _hoisted_72 = { class: "premium-form-card mt-6" };
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-badge-premium localization" }, "Ubicación y Contacto", -1 /* HOISTED */));
const _hoisted_74 = { class: "grid-layout-premium" };
const _hoisted_75 = { class: "input-group-premium full-col" };
const _hoisted_76 = { class: "input-group-premium" };
const _hoisted_77 = { class: "input-group-premium" };
const _hoisted_78 = { class: "input-group-premium" };
const _hoisted_79 = { class: "input-group-premium" };
const _hoisted_80 = { class: "input-group-premium full-col" };
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    id: "almacen-map",
    class: "map-container-premium mt-3"
}, null, -1 /* HOISTED */));
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("small", {
    class: "text-muted text-xs mt-1",
    style: { "color": "#64748b", "font-size": "0.75rem" }
}, "Arrastra el marcador para precisar la ubicación, o escribe en los campos de Ciudad/Estado.", -1 /* HOISTED */));
const _hoisted_83 = { class: "premium-form-footer mt-4" };
const _hoisted_84 = ["disabled"];
const _hoisted_85 = { key: 1 };
const _hoisted_86 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_87 = {
    class: "modal-window",
    style: { "max-width": "800px", "width": "95%" }
};
const _hoisted_88 = { class: "modal-header header-dark-premium" };
const _hoisted_89 = { class: "modal-title-group" };
const _hoisted_90 = {
    class: "icon-bulb-premium",
    style: { "color": "#6366f1", "border-color": "rgba(99, 102, 241, 0.2)" }
};
const _hoisted_91 = { class: "hero-text-content" };
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title-text text-white" }, "Inventario en Stock", -1 /* HOISTED */));
const _hoisted_93 = { class: "rif-subtitle-text" };
const _hoisted_94 = { class: "modal-body bg-light-premium p-0 m-0" };
const _hoisted_95 = { class: "form-scroll-area" };
const _hoisted_96 = {
    key: 0,
    class: "loading-state py-12"
};
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-3 text-muted text-center font-semibold" }, "Sincronizando existencias...", -1 /* HOISTED */));
const _hoisted_98 = { key: 1 };
const _hoisted_99 = { class: "header-top-controls mb-4" };
const _hoisted_100 = {
    class: "search-wrapper",
    style: { "flex": "1", "max-width": "100%" }
};
const _hoisted_101 = { class: "premium-form-card p-0 overflow-hidden" };
const _hoisted_102 = { style: { "padding": "1.25rem 1.5rem", "background": "#eef2ff", "border-bottom": "1px solid #e2e8f0", "display": "flex", "justify-content": "space-between", "align-items": "center" } };
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", {
    class: "card-badge-premium m-0",
    style: { "background": "white", "border": "1px solid #c7d2fe", "color": "#4f46e5" }
}, "Reporte de Existencias", -1 /* HOISTED */));
const _hoisted_104 = {
    class: "font-bold text-sm",
    style: { "color": "#4f46e5" }
};
const _hoisted_105 = { class: "marcas-table" };
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Repuesto (SKU)"),
        /*#__PURE__*/ _createElementVNode("th", { style: { "min-width": "150px" } }, "Stock Físico"),
        /*#__PURE__*/ _createElementVNode("th", { style: { "text-align": "right" } }, "Último Movimiento")
    ])
], -1 /* HOISTED */));
const _hoisted_107 = { style: { "font-weight": "700", "color": "#1e293b", "font-size": "0.95rem" } };
const _hoisted_108 = { style: { "font-size": "0.8rem", "color": "#64748b", "margin-top": "4px", "font-family": "monospace" } };
const _hoisted_109 = {
    class: "attribute-badge",
    style: { "background": "#e0e7ff", "color": "#4338ca", "font-size": "0.9rem", "padding": "0.4rem 0.75rem" }
};
const _hoisted_110 = { style: { "text-align": "right", "color": "#64748b", "font-size": "0.85rem", "font-weight": "500" } };
const _hoisted_111 = { key: 0 };
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "3",
    style: { "text-align": "center", "padding": "3rem 1rem", "color": "#94a3b8", "font-style": "italic", "font-weight": "500" }
}, " No hay registros de inventario que coincidan con la búsqueda. ", -1 /* HOISTED */));
const _hoisted_113 = [
    _hoisted_112
];
const _hoisted_114 = { class: "premium-form-footer mt-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_HomeIcon = _resolveComponent("HomeIcon");
    const _component_TruckIcon = _resolveComponent("TruckIcon");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_LayersIcon = _resolveComponent("LayersIcon");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_Loader2Icon = _resolveComponent("Loader2Icon");
    const _component_PowerIcon = _resolveComponent("PowerIcon");
    const _component_PackageIcon = _resolveComponent("PackageIcon");
    const _component_FileTextIcon = _resolveComponent("FileTextIcon");
    const _component_EditIcon = _resolveComponent("EditIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon");
    const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon");
    const _component_TrasladosTab = _resolveComponent("TrasladosTab");
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_HashIcon = _resolveComponent("HashIcon");
    const _component_BriefcaseIcon = _resolveComponent("BriefcaseIcon");
    const _component_CalendarIcon = _resolveComponent("CalendarIcon");
    const _component_FileUpIcon = _resolveComponent("FileUpIcon");
    const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon");
    const _component_InfoIcon = _resolveComponent("InfoIcon");
    const _component_MaximizeIcon = _resolveComponent("MaximizeIcon");
    const _component_MapPinIcon = _resolveComponent("MapPinIcon");
    const _component_GlobeIcon = _resolveComponent("GlobeIcon");
    const _component_MapIcon = _resolveComponent("MapIcon");
    const _component_PhoneIcon = _resolveComponent("PhoneIcon");
    const _component_MailIcon = _resolveComponent("MailIcon");
    const _component_NavigationIcon = _resolveComponent("NavigationIcon");
    const _component_BoxIcon = _resolveComponent("BoxIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createCommentVNode(" TOP HEADER: TABS + FILTROS "),
                _createElementVNode("div", _hoisted_4, [
                    _createCommentVNode(" TABS PRINCIPALES "),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] = ($event) => ($setup.activeTab = 'almacenes')),
                            class: _normalizeClass([{ active: $setup.activeTab === 'almacenes' }, "tab-btn"])
                        }, [
                            _createVNode(_component_HomeIcon, { size: 16 }),
                            _createTextVNode(" Gestión de Almacenes ")
                        ], 2 /* CLASS */),
                        _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] = ($event) => ($setup.activeTab = 'traslados')),
                            class: _normalizeClass([{ active: $setup.activeTab === 'traslados' }, "tab-btn"])
                        }, [
                            _createVNode(_component_TruckIcon, { size: 16 }),
                            _createTextVNode(" Movimientos y Traslados ")
                        ], 2 /* CLASS */)
                    ]),
                    _createCommentVNode(" CONTROLES ALMACENES "),
                    _withDirectives(_createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_SearchIcon, {
                                    size: 16,
                                    class: "search-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.searchQuery) = $event)),
                                    placeholder: "Buscar por nombre o número...",
                                    class: "search-input text-sm py-2",
                                    onInput: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => ($setup.handleSearch && $setup.handleSearch(...args)))
                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                    [_vModelText, $setup.searchQuery]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_LayersIcon, {
                                    size: 14,
                                    class: "filter-icon"
                                }),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($setup.filterTipoId) = $event)),
                                    class: "filter-input text-sm py-2",
                                    onChange: _cache[5] || (_cache[5] =
                                        //@ts-ignore
                                        (...args) => ($setup.handleSearch && $setup.handleSearch(...args)))
                                }, [
                                    _hoisted_11,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tiposAlmacen, (tipo) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: tipo.tipoAlmacenId,
                                            value: tipo.tipoAlmacenId
                                        }, _toDisplayString(tipo.nombre), 9 /* TEXT, PROPS */, _hoisted_12));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                    [_vModelSelect, $setup.filterTipoId]
                                ])
                            ])
                        ]),
                        ($setup.can($setup.P.ALMACENES.CREATE))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[6] || (_cache[6] = ($event) => ($setup.openCreateModal())),
                                class: "btn btn-add text-sm py-2 px-3"
                            }, [
                                _createVNode(_component_PlusIcon, { size: 16 }),
                                _hoisted_13
                            ]))
                            : _createCommentVNode("v-if", true)
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, $setup.activeTab === 'almacenes']
                    ]),
                    _createCommentVNode(" CONTROLES TRASLADOS (Teleport Target) "),
                    _withDirectives(_createElementVNode("div", _hoisted_14, null, 512 /* NEED_PATCH */), [
                        [_vShow, $setup.activeTab === 'traslados']
                    ])
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("button", {
                                onClick: _cache[7] || (_cache[7] =
                                    //@ts-ignore
                                    (...args) => ($setup.resetLetterFilter && $setup.resetLetterFilter(...args))),
                                class: _normalizeClass([{ active: !$setup.selectedLetter }, "alphabet-button all-button"])
                            }, " Todos ", 2 /* CLASS */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.alphabet, (letter) => {
                                return (_openBlock(), _createElementBlock("button", {
                                    key: letter,
                                    onClick: ($event) => ($setup.filterByLetter(letter)),
                                    class: _normalizeClass([{ active: $setup.selectedLetter === letter }, "alphabet-button"])
                                }, _toDisplayString(letter), 11 /* TEXT, CLASS, PROPS */, _hoisted_17));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]),
                    _createCommentVNode(" Tabla Estilo Tienda Retail "),
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("table", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("tbody", null, [
                                ($setup.isLoading)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                                        _createElementVNode("td", _hoisted_22, [
                                            _createElementVNode("div", _hoisted_23, [
                                                _createVNode(_component_Loader2Icon, {
                                                    class: "spinner-icon text-primary",
                                                    size: 32
                                                }),
                                                _hoisted_24
                                            ])
                                        ])
                                    ]))
                                    : ($setup.almacenes.length === 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_25, _hoisted_27))
                                        : _createCommentVNode("v-if", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.almacenes, (store) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: store.almacenId
                                    }, [
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", _hoisted_28, " #" + _toDisplayString(store.numeroAlmacen), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_29, _toDisplayString(store.nombreAlmacen), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("span", _hoisted_31, _toDisplayString(store.ciudad), 1 /* TEXT */),
                                                _createElementVNode("span", _hoisted_32, _toDisplayString(store.estadoDir), 1 /* TEXT */)
                                            ])
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", _hoisted_33, _toDisplayString(store.tipoAlmacenNombre), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["status-badge", store.activo ? 'active' : 'inactive'])
                                            }, _toDisplayString(store.activo ? 'Activo' : 'Inactivo'), 3 /* TEXT, CLASS */)
                                        ]),
                                        _createElementVNode("td", _hoisted_34, [
                                            _createElementVNode("button", {
                                                onClick: ($event) => ($setup.toggleActivo(store)),
                                                class: "btn-icon btn-toggle",
                                                title: store.activo ? 'Desactivar' : 'Activar'
                                            }, [
                                                _createVNode(_component_PowerIcon, {
                                                    size: 18,
                                                    class: _normalizeClass(store.activo ? 'text-success' : 'text-danger')
                                                }, null, 8 /* PROPS */, ["class"])
                                            ], 8 /* PROPS */, _hoisted_35),
                                            _createElementVNode("button", {
                                                onClick: ($event) => ($setup.openInventoryModal(store)),
                                                class: "btn-icon btn-inventory",
                                                title: "Ver Inventario"
                                            }, [
                                                _createVNode(_component_PackageIcon, {
                                                    size: 18,
                                                    style: { "color": "#6366f1" }
                                                })
                                            ], 8 /* PROPS */, _hoisted_36),
                                            (store.rutaActaRegistroPdf)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    href: store.rutaActaRegistroPdf,
                                                    target: "_blank",
                                                    class: "btn-icon btn-view",
                                                    title: "Ver Acta PDF"
                                                }, [
                                                    _createVNode(_component_FileTextIcon, { size: 18 })
                                                ], 8 /* PROPS */, _hoisted_37))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.ALMACENES.EDIT))
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    onClick: ($event) => ($setup.editAlmacen(store)),
                                                    class: "btn-icon btn-edit",
                                                    title: "Editar"
                                                }, [
                                                    _createVNode(_component_EditIcon, { size: 18 })
                                                ], 8 /* PROPS */, _hoisted_38))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.ALMACENES.DELETE))
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 2,
                                                    onClick: ($event) => ($setup.confirmDelete(store)),
                                                    class: "btn-icon btn-delete",
                                                    title: "Eliminar"
                                                }, [
                                                    _createVNode(_component_TrashIcon, { size: 18 })
                                                ], 8 /* PROPS */, _hoisted_39))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("button", {
                            onClick: _cache[8] || (_cache[8] =
                                //@ts-ignore
                                (...args) => ($setup.prevPage && $setup.prevPage(...args))),
                            disabled: $setup.currentPage === 1,
                            class: "btn-pagination"
                        }, [
                            _createVNode(_component_ChevronLeftIcon, { size: 16 }),
                            _createTextVNode(" Anterior ")
                        ], 8 /* PROPS */, _hoisted_41),
                        _createElementVNode("span", null, [
                            _createTextVNode("Página "),
                            _createElementVNode("strong", null, _toDisplayString($setup.currentPage), 1 /* TEXT */),
                            _createTextVNode(" de "),
                            _createElementVNode("strong", null, _toDisplayString($setup.totalPages), 1 /* TEXT */)
                        ]),
                        _createElementVNode("button", {
                            onClick: _cache[9] || (_cache[9] =
                                //@ts-ignore
                                (...args) => ($setup.nextPage && $setup.nextPage(...args))),
                            disabled: $setup.currentPage === $setup.totalPages,
                            class: "btn-pagination"
                        }, [
                            _createTextVNode(" Siguiente "),
                            _createVNode(_component_ChevronRightIcon, { size: 16 })
                        ], 8 /* PROPS */, _hoisted_42)
                    ]),
                    _createElementVNode("div", _hoisted_43, " Total Almacenes Registrados: " + _toDisplayString($setup.totalCount), 1 /* TEXT */)
                ], 512 /* NEED_PATCH */), [
                    [_vShow, $setup.activeTab === 'almacenes']
                ]),
                _createCommentVNode(" Fin v-show almacenes "),
                _createCommentVNode(" VISTA TRASLADOS "),
                ($setup.activeTab === 'traslados')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createVNode(_component_TrasladosTab)
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ]),
        _createCommentVNode(" Modal Estilo Tienda Retail "),
        _createVNode(_Transition, { name: "modal-fade" }, {
            default: _withCtx(() => [
                ($setup.isModalOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                        _createVNode(_component_HomeIcon, { size: 24 })
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("h2", _hoisted_51, _toDisplayString($setup.isEditing ? 'Editar Almacén' : 'Nuevo Almacén'), 1 /* TEXT */),
                                        _hoisted_52
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[10] || (_cache[10] =
                                        //@ts-ignore
                                        (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                    class: "btn-close-dark-premium"
                                }, [
                                    _createVNode(_component_XIcon, { size: 24 })
                                ])
                            ]),
                            _createElementVNode("form", {
                                onSubmit: _cache[29] || (_cache[29] = _withModifiers(
                                //@ts-ignore
                                (...args) => ($setup.saveAlmacen && $setup.saveAlmacen(...args)), ["prevent"])),
                                class: "modal-body bg-light-premium p-0 m-0"
                            }, [
                                _createElementVNode("div", _hoisted_53, [
                                    _createCommentVNode(" ID Legal "),
                                    _createElementVNode("div", _hoisted_54, [
                                        _hoisted_55,
                                        _createElementVNode("div", _hoisted_56, [
                                            _createElementVNode("div", _hoisted_57, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_HashIcon, { size: 14 }),
                                                    _createTextVNode(" Expediente ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => (($setup.form.numeroExpediente) = $event)),
                                                    placeholder: "Ej: 223-32131",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.numeroExpediente]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_58, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_FileTextIcon, { size: 14 }),
                                                    _createTextVNode(" Tomo ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => (($setup.form.numeroTomo) = $event)),
                                                    placeholder: "Ej: 47-A",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.numeroTomo]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_59, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_BriefcaseIcon, { size: 14 }),
                                                    _createTextVNode(" Registro Mercantil ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => (($setup.form.nombreRegistroMercantil) = $event)),
                                                    placeholder: "Oficina de registro oficial",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.nombreRegistroMercantil]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_60, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_CalendarIcon, { size: 14 }),
                                                    _createTextVNode(" Nro / Año Registro ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => (($setup.form.numeroRegistro) = $event)),
                                                    placeholder: "Ej: 006 del 2024",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.numeroRegistro]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_61, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_FileUpIcon, { size: 14 }),
                                                    _createTextVNode(" Acta (PDF) ")
                                                ]),
                                                _createElementVNode("div", {
                                                    class: "file-drop-zone-retail",
                                                    onClick: _cache[16] || (_cache[16] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.triggerFileInput && $setup.triggerFileInput(...args)))
                                                }, [
                                                    (!$setup.selectedFile)
                                                        ? (_openBlock(), _createBlock(_component_FileUpIcon, {
                                                            key: 0,
                                                            size: 20
                                                        }))
                                                        : (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                                                            key: 1,
                                                            size: 20,
                                                            class: "text-success"
                                                        })),
                                                    _createElementVNode("span", _hoisted_62, _toDisplayString($setup.selectedFile ? $setup.selectedFile.name : 'Vincular documento PDF'), 1 /* TEXT */),
                                                    _createElementVNode("input", {
                                                        type: "file",
                                                        ref: "fileInput",
                                                        hidden: "",
                                                        accept: ".pdf",
                                                        onChange: _cache[15] || (_cache[15] =
                                                            //@ts-ignore
                                                            (...args) => ($setup.onFileChange && $setup.onFileChange(...args)))
                                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createCommentVNode(" Operación "),
                                    _createElementVNode("div", _hoisted_63, [
                                        _hoisted_64,
                                        _createElementVNode("div", _hoisted_65, [
                                            _createElementVNode("div", _hoisted_66, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_InfoIcon, { size: 14 }),
                                                    _createTextVNode(" Nombre del Almacén ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => (($setup.form.nombreAlmacen) = $event)),
                                                    placeholder: "Ej: Almacén Central",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.nombreAlmacen]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_67, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_HashIcon, { size: 14 }),
                                                    _createTextVNode(" Código Almacén ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => (($setup.form.numeroAlmacen) = $event)),
                                                    placeholder: "Ej: A-001",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.numeroAlmacen]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_68, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_LayersIcon, { size: 14 }),
                                                    _createTextVNode(" Tipo de Almacén ")
                                                ]),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => (($setup.form.tipoAlmacenId) = $event)),
                                                    required: ""
                                                }, [
                                                    _hoisted_69,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tiposAlmacen, (t) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: t.tipoAlmacenId,
                                                            value: t.tipoAlmacenId
                                                        }, _toDisplayString(t.nombre), 9 /* TEXT, PROPS */, _hoisted_70));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, $setup.form.tipoAlmacenId]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_71, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_MaximizeIcon, { size: 14 }),
                                                    _createTextVNode(" Capacidad (m²) ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    step: "0.01",
                                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => (($setup.form.capacidadM2) = $event)),
                                                    placeholder: "0.00"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.capacidadM2]
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createCommentVNode(" Ubicación "),
                                    _createElementVNode("div", _hoisted_72, [
                                        _hoisted_73,
                                        _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("div", _hoisted_75, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_MapPinIcon, { size: 14 }),
                                                    _createTextVNode(" Dirección Exacta ")
                                                ]),
                                                _withDirectives(_createElementVNode("textarea", {
                                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => (($setup.form.direccion) = $event)),
                                                    rows: "2",
                                                    placeholder: "Av, Galpón, Zona Industrial...",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.direccion]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_76, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_GlobeIcon, { size: 14 }),
                                                    _createTextVNode(" Ciudad / Municipio ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => (($setup.form.ciudad) = $event)),
                                                    placeholder: "Ciudad",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.ciudad]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_77, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_MapIcon, { size: 14 }),
                                                    _createTextVNode(" Estado ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => (($setup.form.estadoDir) = $event)),
                                                    placeholder: "Estado",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.estadoDir]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_78, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_PhoneIcon, { size: 14 }),
                                                    _createTextVNode(" Teléfono ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => (($setup.form.telefono) = $event)),
                                                    placeholder: "Opcional"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.telefono]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_79, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_MailIcon, { size: 14 }),
                                                    _createTextVNode(" Email de Contacto ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "email",
                                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => (($setup.form.email) = $event)),
                                                    placeholder: "almacen@empresa.com"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.email]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_80, [
                                                _createElementVNode("label", null, [
                                                    _createVNode(_component_NavigationIcon, { size: 14 }),
                                                    _createTextVNode(" Coordenadas GPS (Lat, Long) ")
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => (($setup.form.coordenadasGps) = $event)),
                                                    placeholder: "10.4806, -66.9036",
                                                    onChange: _cache[27] || (_cache[27] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.updateMapFromInput && $setup.updateMapFromInput(...args)))
                                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [_vModelText, $setup.form.coordenadasGps]
                                                ]),
                                                _hoisted_81,
                                                _hoisted_82
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_83, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-ghost-premium",
                                        onClick: _cache[28] || (_cache[28] =
                                            //@ts-ignore
                                            (...args) => ($setup.closeModal && $setup.closeModal(...args)))
                                    }, "Cancelar"),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn-primary-premium",
                                        disabled: $setup.isSaving
                                    }, [
                                        ($setup.isSaving)
                                            ? (_openBlock(), _createBlock(_component_Loader2Icon, {
                                                key: 0,
                                                class: "spinner-icon",
                                                size: 20
                                            }))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString($setup.isEditing ? 'Actualizar Información' : 'Registrar Almacén'), 1 /* TEXT */))
                                    ], 8 /* PROPS */, _hoisted_84)
                                ])
                            ], 32 /* NEED_HYDRATION */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        }),
        _createCommentVNode(" MODAL DE INVENTARIO (PREMIUM DESIGN) "),
        _createVNode(_Transition, { name: "modal-fade" }, {
            default: _withCtx(() => [
                ($setup.isInventoryModalOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("div", _hoisted_89, [
                                    _createElementVNode("div", _hoisted_90, [
                                        _createVNode(_component_PackageIcon, { size: 24 })
                                    ]),
                                    _createElementVNode("div", _hoisted_91, [
                                        _hoisted_92,
                                        _createElementVNode("span", _hoisted_93, "Almacén: " + _toDisplayString($setup.selectedAlmacen?.nombreAlmacen) + " (#" + _toDisplayString($setup.selectedAlmacen?.numeroAlmacen) + ")", 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[30] || (_cache[30] =
                                        //@ts-ignore
                                        (...args) => ($setup.closeInventoryModal && $setup.closeInventoryModal(...args))),
                                    class: "btn-close-dark-premium"
                                }, [
                                    _createVNode(_component_XIcon, { size: 24 })
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                                _createElementVNode("div", _hoisted_95, [
                                    ($setup.isInventoryLoading)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                            _createVNode(_component_Loader2Icon, {
                                                class: "spinner-icon text-indigo-500 mx-auto",
                                                size: 36
                                            }),
                                            _hoisted_97
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                            _createElementVNode("div", _hoisted_99, [
                                                _createElementVNode("div", _hoisted_100, [
                                                    _createVNode(_component_SearchIcon, {
                                                        class: "search-icon",
                                                        size: 20
                                                    }),
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => (($setup.searchInventoryQuery) = $event)),
                                                        placeholder: "Filtrar stock por repuesto o código único...",
                                                        class: "search-input",
                                                        style: { "background": "white" }
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, $setup.searchInventoryQuery]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_101, [
                                                _createElementVNode("div", _hoisted_102, [
                                                    _hoisted_103,
                                                    _createElementVNode("span", _hoisted_104, "Total Ítems: " + _toDisplayString($setup.filteredInventory.length), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("table", _hoisted_105, [
                                                    _hoisted_106,
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredInventory, (item) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                                key: item.inventarioId,
                                                                style: { "transition": "all 0.2s" }
                                                            }, [
                                                                _createElementVNode("td", null, [
                                                                    _createElementVNode("div", _hoisted_107, _toDisplayString(item.nombreProducto), 1 /* TEXT */),
                                                                    _createElementVNode("div", _hoisted_108, _toDisplayString(item.codigoUnico), 1 /* TEXT */)
                                                                ]),
                                                                _createElementVNode("td", null, [
                                                                    _createElementVNode("span", _hoisted_109, [
                                                                        _createVNode(_component_BoxIcon, {
                                                                            size: 14,
                                                                            style: { "display": "inline", "margin-top": "-2px", "margin-right": "4px" }
                                                                        }),
                                                                        _createTextVNode(" " + _toDisplayString(parseFloat(item.stockActual).toFixed(2)) + " UND ", 1 /* TEXT */)
                                                                    ])
                                                                ]),
                                                                _createElementVNode("td", _hoisted_110, _toDisplayString($setup.formatDate(item.fechaUltimaActualizacion)), 1 /* TEXT */)
                                                            ]));
                                                        }), 128 /* KEYED_FRAGMENT */)),
                                                        ($setup.filteredInventory.length === 0)
                                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_111, _hoisted_113))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ])
                                            ])
                                        ]))
                                ]),
                                _createElementVNode("div", _hoisted_114, [
                                    _createElementVNode("button", {
                                        onClick: _cache[32] || (_cache[32] =
                                            //@ts-ignore
                                            (...args) => ($setup.closeInventoryModal && $setup.closeInventoryModal(...args))),
                                        class: "btn-ghost-premium"
                                    }, " Cerrar Panel ")
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        })
    ]));
}
